import { isThisArrayNotEmpty } from "../../../services/helpers/commonHelpers";
import {
  FieldType,
  FieldTypeType,
  ReportFieldType,
} from "../../../services/helpers/types";

export const bindFieldsToReport = (fields: ReportFieldType[]) => {
  if (isThisArrayNotEmpty(fields)) {
    const result = fields.map((field) => {
      const data = transformFieldDataToReportData(field.data);
      const tabId = field.tab ? field.tab : "";
      const tabName = field.name ? field.name : "";
      const tabValue = field.value ? field.value : "";

      const tabSpacer = {
        id: tabId,
        value: tabValue,
        name: tabName,
        unit: null,
        position: 0,
        type: FieldTypeType.Spacer,
      };
      const merged = [tabSpacer, ...data];

      return merged;
    });
    return result.flat();
  }
  return [];
};

const transformFieldDataToReportData = (fields: FieldType[]) => {
  return fields.map((field: any) => {
    const currentValue =
      field.type === FieldTypeType.Button ? "" : field.defaultValue;
    return {
      id: field.fieldID,
      value: currentValue,
      name: field.name,
      position: field.position,
      unit: field.unit,
      type: field.type,
    };
  });
};
